// eslint-disable-next-line
import I18n from '/src/utils/translations'

export default function includeGeneralSection(sections) {
  if (!sections) return []
  return [{ id: 'general', title: I18n.t('form.general_information') }, ...sections]
}
